import { Component, OnInit } from '@angular/core';

import { AppoinmentserviceService } from '../add-appoinments/appoinmentservice.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-showhospital',
  templateUrl: './showhospital.component.html',
  styleUrls: ['./showhospital.component.scss']
})
export class ShowhospitalComponent implements OnInit {
  doctord: any;
  

  constructor(private AppoinmentserviceService: AppoinmentserviceService, private dialogRef: MatDialogRef<ShowhospitalComponent>) { }

  ngOnInit(): void {
    this.get_doctordd
  }

  get_doctordd(){
    this.AppoinmentserviceService.get_doctordd()
    .subscribe((data)=> {
      this.doctord = data
      console.log('dock' , this.doctord)
    })

}
  get_test(data:any) {
    console.log('test', data)
    this.dialogRef.close(data);
}

}
